// GlowBorderWrapper.jsx
import React from 'react';
import './GlowBorder.css';

const GlowBorderWrapper = ({ children, animated = false }) => {
  const wrapperClasses = `glow-border-wrapper ${animated ? 'glow-border-animated' : ''}`;

  return (
    <div className={wrapperClasses}>
      {children}
    </div>
  );
};

export default GlowBorderWrapper;
